import { tokens } from '../../../theme/tokens';
import { AccordionConfig } from '../../../types/accordion';
import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;
const PREVIEWS = `${BASE}/previews/seasonality`;
const COVER_HELPER = ['JPG, PNG', '1080x1920 px', 'Imagen vertical'];

const ACCORDION_CONFIG: AccordionConfig[] = [
  {
    key: 'general',
    title: 'Información general',
    subtitle: 'Datos básicos del banner',
    fields: ['title', 'edit_title'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'content1',
    title: 'Contenido 1',
    subtitle: 'Primer elemento del banner',
    fields: ['edit_t1', 'edit_image_1', 'edit_logo1'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[100]
  },
  {
    key: 'content2',
    title: 'Contenido 2',
    subtitle: 'Segundo elemento del banner',
    fields: ['edit_t2', 'edit_image_2', 'edit_logo2'],
    defaultOpen: false,
    color: tokens.colors.brands.blue[100]
  },
  {
    key: 'content3',
    title: 'Contenido 3',
    subtitle: 'Tercer elemento del banner',
    fields: ['edit_t3', 'edit_image_3', 'edit_logo3'],
    defaultOpen: false,
    color: tokens.colors.brands.blue[100]
  },
  {
    key: 'content4',
    title: 'Contenido 4',
    subtitle: 'Cuarto elemento del banner',
    fields: ['edit_t4', 'edit_image_4', 'edit_logo4'],
    defaultOpen: false,
    color: tokens.colors.brands.blue[100]
  },
  {
    key: 'content5',
    title: 'Contenido 5',
    subtitle: 'Quinto elemento del banner',
    fields: ['edit_t5', 'edit_image_5', 'edit_logo5'],
    defaultOpen: false,
    color: tokens.colors.brands.blue[100]
  }
];

export const disneySeasonality = defineTemplate({
  mode: 'legacy',
  id: 'seasonality-300x600',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Seasonality',
  thumbnail: {
    url: `${BASE}/thumbnails/seasonality.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/seasonality.png`,

    aspectRatio: 'vertical'
  },
  previewByResolution: {
    '300x250': { kind: 'video', url: `${PREVIEWS}/seasonality_300x250.mp4` },
    '300x600': { kind: 'video', url: `${PREVIEWS}/seasonality_300x600.mp4` },
    '1080x1350': { kind: 'video', url: `${PREVIEWS}/seasonality_1080x1350.mp4` },
    '1080x1080': { kind: 'video', url: `${PREVIEWS}/seasonality_1080x1080.mp4` },
    '1080x1920': { kind: 'video', url: `${PREVIEWS}/seasonality_1080x1920.mp4` },
    '1920x1080': { kind: 'video', url: `${PREVIEWS}/seasonality_1920x1080.mp4` }
  },
  renderConfig: { renderer: 'accordion', accordionConfig: ACCORDION_CONFIG },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'edit_title',
      label: 'Temática',
      type: 'input',
      placeholder: 'Películas que celebran la amistad',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/seasonality/subject.png'
    },
    {
      key: 'edit_t1',
      label: 'Zócalo',
      type: 'input',
      placeholder: 'Maui y Moana',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/seasonality/plinth.png'
    },
    {
      key: 'edit_image_1',
      label: 'Portada',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada1.jpg',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/seasonality/cover.png',
      helperText: COVER_HELPER
    },
    {
      key: 'edit_logo1',
      label: 'Logo',
      type: 'image',
      placeholder: '',
      required: false,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/seasonality/logo.png'
    },
    { key: 'edit_t2', label: 'Zócalo', type: 'input', placeholder: 'Rayo MacQueen y Mate', required: true },
    {
      key: 'edit_image_2',
      label: 'Portada',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada2.jpg',
      required: true,
      helperText: COVER_HELPER
    },
    { key: 'edit_logo2', label: 'Logo', type: 'image', placeholder: '', required: false },
    { key: 'edit_t3', label: 'Zócalo', type: 'input', placeholder: 'Meilin, Priya, Miriam y Abby', required: true },
    {
      key: 'edit_image_3',
      label: 'Portada',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada3.jpg',
      required: true,
      helperText: COVER_HELPER
    },
    { key: 'edit_logo3', label: 'Logo', type: 'image', placeholder: '', required: false },
    { key: 'edit_t4', label: 'Zócalo', type: 'input', placeholder: 'Judy y Nick', required: true },
    {
      key: 'edit_image_4',
      label: 'Portada',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada4.jpg',
      required: true,
      helperText: COVER_HELPER
    },
    { key: 'edit_logo4', label: 'Logo', type: 'image', placeholder: '', required: false },
    { key: 'edit_t5', label: 'Zócalo', type: 'input', placeholder: 'Joe y 22', required: true },
    {
      key: 'edit_image_5',
      label: 'Portada',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada5.jpg',
      required: true,
      helperText: COVER_HELPER
    },
    { key: 'edit_logo5', label: 'Logo', type: 'image', placeholder: '', required: false }
  ],
  promptTemplate: `Haceme un vertical seasonality usando las portadas de estas 5 películas:
1. "título 1", 2. "título 2", 3. "título 3", 4. "título 4", 5. "título 5"
Tema: "Películas que celebran la amistad"
Textos: 1. "texto 1", 2. "texto 2", 3. "texto 3", 4. "texto 4", 5. "texto 5"`
});
